<div class="flex flex-row">
  <!--<span>{{messageObj.createdBy.firstName}}:</span>-->
  <span [innerHTML]="speech.message | sanitizeHtml"></span>
</div>
<div class="flex flex-row justify-end items-center">
  <span class="timing">
  {{speech.createdDate | date:'medium'}}
  </span>
</div>
